<div class="col-12 feature-item"  [style]="{'background-color': backColor,'color':fontColor}">
    <div class="col-12" >
        <img draggable="false" class="logo" src="{{logoPath}}">
    </div>
    <h2 class="title">
        {{title}}
    </h2>
    <p class="text">
        {{text}}
    </p>
    <div class="more-div" style="height: 33px" >
        <div class="more-btn" (click)="goToPage()" > <span i18n="@@See more">See more</span>
            <i *ngIf="getDirection()=='rtl'" class="pi pi-angle-left"></i>
            <i *ngIf="getDirection()=='ltr'" class="pi pi-angle-right"></i>
        </div>
    </div>


</div>